import { useMemo } from 'react';

export default function useCombinationFilters(combinations) {
  const { activeCombinations, deletionInProgressCombinations } = useMemo(() => {
    const activeCombinations = combinations.filter(({ isBeingDeleted }) => !isBeingDeleted);
    const deletionInProgressCombinations = combinations.filter(
      ({ isBeingDeleted }) => isBeingDeleted,
    );

    return {
      activeCombinations,
      deletionInProgressCombinations,
    };
  }, [combinations]);

  return { activeCombinations, deletionInProgressCombinations };
}
